import LeadPipelineEntry from "./LeadPipelineEntry";

export default function LeadPipelineLane({
  stage,
  leads,
  onStatusChange,
  savedLeadId,
  savingLeadId,
}) {
  return (
    <section
      className="lead-pipeline-lane"
      data-testid={`lead-pipeline-lane-${stage.value}`}
    >
      <header>
        <h3>{stage.label}</h3>
        <span data-testid={`lead-pipeline-count-${stage.value}`}>{leads.length}</span>
      </header>
      <div className="lead-pipeline-list">
        {leads.map((lead) => (
          <LeadPipelineEntry
            key={lead.lead_id}
            lead={lead}
            onStatusChange={onStatusChange}
            savedLeadId={savedLeadId}
            savingLeadId={savingLeadId}
          />
        ))}
        {!leads.length && <p className="lead-pipeline-none">No leads</p>}
      </div>
    </section>
  );
}